import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Box, Typography } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

const UIList = ({ children, ...rest }) => {
  return <List {...rest}>{children}</List>;
};

export default UIList;

export const UIListItem = ({
  title,
  handleItemClick = () => {},
  handleSubItemClick = null,
  expanded,
  id,
  subItems = [],
  children = null,
  selected = "",
  parentSelected = "",
  headingStyle = {},
  sx = {},
  textStyle = {},
  collapseStyle = {},
  disabled = false,
  accordionHeaderRight = null,
  className = "",
  showArrow = true,
  multipleExpand = false,
}) => {
  const openState = multipleExpand ? expanded : expanded == id;
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
        <ListItemButton
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleItemClick(openState ? "" : id);
          }}
          selected={
            // selected === id ||
            // parentSelected === id ||
            // (multipleExpand && expanded)
            multipleExpand && expanded && !showArrow
          }
          sx={sx}
          disabled={disabled}
          className={className}
          tabIndex={-1}
        >
          <ListItemText
            aria-disabled={true}
            primary={<Typography sx={textStyle}> {title}</Typography>}
            sx={headingStyle}
          />
          {showArrow ? (
            (subItems && subItems.length) || children ? (
              openState ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )
            ) : null
          ) : null}
        </ListItemButton>
        {accordionHeaderRight && (
          <Box
            sx={{
              position: "absolute",
              right: "8px",
              top: "12px",
            }}
          >
            {accordionHeaderRight}
          </Box>
        )}
      </Box>
      {children ? (
        <Collapse
          in={openState}
          timeout="auto"
          unmountOnExit
          sx={{ my: 1, ...collapseStyle }}
        >
          {children}
        </Collapse>
      ) : subItems.length ? (
        <Collapse
          in={openState}
          timeout="auto"
          unmountOnExit
          sx={{ width: "93%", marginLeft: "auto", my: 1, collapseStyle }}
        >
          <List component="div" disablePadding>
            {subItems.map((ch, ch_index) => (
              <ListItemButton
                sx={{ pl: 4 }}
                key={ch_index}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleSubItemClick(ch);
                }}
                selected={ch?.id === selected}
                tabIndex={-1}
              >
                <ListItemText primary={ch.title} />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      ) : null}
    </>
  );
};
